<template>
  <div v-if="loading" class="spinner-container">
    <div class="spinner"></div>
  </div>
  <div v-else>
    <!-- Keep-alive should wrap <router-view /> -->

    <div class="homepage d-flex flex-column vh-100">
      <!-- navbar -->
      <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary">
        <div class="d-flex align-items-center">

          <span @click="goBack()" class="text-white"><i class="bi bi-arrow-left fs-5"></i></span> &nbsp; &nbsp;

          <span>
            <h4 class="text-white">Customer List</h4>
          </span>
  
        </div>




      </div>

      <!-- body -->
      <div class="my-auto overflow-auto vh-100">
         <div class="container bg_card  ">

          <div class="  pt-2 row">

             <div class="Row mb-2 mt-2">
              <span :class="isDueBtn?'badge bg-primary p-2':'badge bg-success p-2'" @click="filteralldueList">
                <i class="bi bi-check"></i> &nbsp;{{ language?.due_list }} 
              </span> &nbsp; &nbsp;
    
              <span class="badge bg-success p-2"  @click="getNewOrderBasics('')">
                <i class="bi bi-check"></i> &nbsp;{{ language?.all_list }} 
              </span>
              </div>

            <div class="col-12 pb-1">
              <input type="text" v-model="search_txt" placeholder="येथे ग्राहक शोधा" class="form-control">
            </div>
            <div class="  border-1 overflow-hidden col-12" v-for="(customer,i) in filteredcustomerList"
               >
             
              <div class="card card-body p-1 text-dark">
                
                <div class="text-muted">{{ language?.bill_no }}. #{{customer.id}}  <span class="float-right">{{ language?.date }}: {{customer.iddate}}</span></div>
                <div> <strong style="color: black;">{{ customer.name }}</strong></div>
                <div>
                    <strong>
                      <i class="bi bi-telephone-fill"></i> &nbsp;
                      <a :href="'tel:' + customer.contact">{{ customer.contact }}</a>
                    </strong>
                  </div>                  
                <div style="color: grey;"> <i class="bi bi-house"></i > {{ customer.address }}</div>
                <div class="row">
                <div class="col-4" style="color: black;">{{ language?.total }}</div>
                <div class="col-4" style="color: black;">{{ language?.paid }}</div>
                <div class="col-4" style="color: black;">{{ language?.due }}</div> 


                <div class="col-4" style="color: red;"> {{customer.totalamt}}</div>
                <div class="col-4" style="color: red;">  {{customer.paidtotal}}</div>
                <div class="col-4" style="color: red;"> {{customer.dueamt}}</div>  
            </div>  
                       
                <div>
                    <router-link :to="'/customerDetails?id='+customer.id" class="badge bg-success" >
                        <i class="bi bi-plus"></i> &nbsp; {{ language?.all_history }}
                    </router-link>      
&nbsp;&nbsp;
                  <span class="badge btn-primary" @click="addvoucher(customer.id)">
                    <i class="bi bi-plus"></i> &nbsp; Add Voucher
                  </span>
                </div>
              </div> 
            </div>
         </div>
          </div>
             
 
          <div class="offcanvas offcanvas-end border-0" tabindex="-1" id="showvoucher" aria-labelledby="voucherLabel">
            <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
               <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i class="bi bi-arrow-left fs-5 text-white"></i></a>
               <h6 class="offcanvas-title text-white m-0" id="voucherLabel">Add Voucher</h6>
            </div>
            <div class="offcanvas-body">
              
                   
                       <div class="mb-3">
                           <label for="date" class="form-label">Date</label>
                           <input type="date" id="date" v-model="voucher.voucher_date" class="form-control" required>
                       </div>
   
                       <div class="mb-3">
                        <label for="amount" class="form-label">Amount</label>
                        <input type="number" id="amount" v-model="voucher.amount" class="form-control" required>
                    </div>
   
                    <div class="mb-3">
                        <label for="remark" class="form-label">Remark</label>
                        <textarea id="remark" v-model="voucher.remark" class="form-control" rows="2" required></textarea>
                    </div>
                    
                       
                     <div class="d-flex gap-2">
                        <button class="btn btn-primary w-100 " @click="savevoucher">Save</button>
                       
                     </div>
                    
            </div>
         </div>






      </div>

   


    
    </div>
  </div>
</template>
<style>
.float-right{
    float: right;
}
.bottom_border{
        border-bottom: 1px solid gray;
}
.footer_area{
        position: fixed;
        width: -webkit-fill-available;
        bottom: 0;
        background: aliceblue;
        padding: 5px 10px;
}
    .custom_height {
           min-height: 80vh;
        max-height: 80vh;
        overflow-y: auto;
    }
</style>
<script>
import axios from "@/plugins/axios";
import { reactive } from "vue";

  export default {
    name: 'Branch',
    components: {
    },
    
    
    mounted() {
      //  this.fetchWeather();

       if(this.$route.query.id){
        this.getNewOrderBasics(this.$route.query.id);
       }else{
       this.getNewOrderBasics();
    // Call the method here
       }

    },
    watch: {
      search_txt(newVal) {
        this.filteredcustomerList = this.customerlist.filter((item) =>
        //   item.name.toLowerCase().includes(newVal.toLowerCase())
           (item.name ? item.name.toLowerCase().includes(newVal.toLowerCase()) : false) ||
            (item.contact ? item.contact.toString().includes(newVal) : false)
            
        );
      },
       
    },
    data() {
      return { 
        loading: false,
        error: null,
        isUserLogged: false,
        user_details: [],
        customerlist: [],
        productsCostList: [],
        filteredproductsCostList: [],
        filteredcustomerList: [],
        selected: [],
        customers: [],
        selected_services: {},
        order_products_services: {},
        language:this.getLocalStorageArray('lang'),

        voucher:{
        voucher_date:new Date().toISOString().split('T')[0],
        amount:'',
        remark:'',
        custid:0

      },
        customer:{
          name:'',
          contact:'',
          address:'',
        },

    
        
        search_txt: '',
        isDueBtn:false,

      }
    },
    methods: {
      initializeHomeContent() {


      },
      goBack() {
          
          this.$router.go(-1);
  },
             
      async getNewOrderBasics(id="") {
        this.loading = true;
        this.error = null;
        if(id!="")
        this.isDueBtn = true;
      else
        this.isDueBtn = false;

        try {
          var self = this;
          axios.post("getcustomerlist",{_id:id}).then((response) => {
            self.productsCostList = response.data.cost;
            self.servicesList = response.data.servicesLists;
            self.customerlist = response.data.customerlist;
            self.filteredcustomerList = self.customerlist; 

            self.language=response.data.language;
            localStorage.setItem('lang',response.data.language);

          }).then(() => {
            self.initializeHomeContent();

            $("#customers").select2({
              width: '100%',
              placeholder: "Search Services Here...",
              "language": {
                "noResults": function () {
                  return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                }
              },
              escapeMarkup: function (markup) {
                return markup;
              }
            }).on('change', function (event) {
                self.order.cust_id= $(this).val(); 
                
            });
          }).catch((err) => {

          });;


        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      },

      

      addvoucher(custid) {
        
         window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("showvoucher")).show();
          this.voucher.custid=custid;
          
      }, 

     
     
     customerBack(){
          window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("customer")).hide();
     } ,
       serviceBack(){
          window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("cost")).hide();
     } ,
 
    savevoucher() {
    this.loading = true;
    this.error = null;

    try {
        var self = this;
        if (self.voucher.custid < 0) {
            self.$swal.fire("Empty Customer");
        } else if (self.voucher.amount == '') {
            self.$swal.fire("Amount is empty");
        } else {
          if(self.isDueBtn)
            self.voucher.due=1;
          else
            self.voucher.due=0;
        
            axios.post("savevoucherdata", self.voucher).then((response) => {
                
            self.customerlist = response.data.customerlist;
            self.filteredcustomerList = self.customerlist; 

                self.$swal.fire(response.data.message);
                if (response.data.success) {
                    self.voucher = { voucher_date: '', amount: '', remark: '', custid: 0 };
                }
                
                window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("showvoucher")).hide();
            }).then(() => {
                self.initializeHomeContent();
            });
        }
    } catch (error) {
        console.error(error);
        self.$swal.fire("An error occurred while saving the voucher.");
    } finally {
        this.loading = false;
    }
},

     
      
getLocalStorageArray(key) {
        let data = localStorage?.getItem(key);
        try {
            return data ? JSON.parse(data) : [];
        } catch (e) {
            console.error("Error parsing localStorage data", e);
            return [];
        }
    },
    
    


       filteralldueList(duelist) {
        this.loading = true;
        this.isDueBtn = true;
        this.error = null;

        try {
          var self = this;
          axios.post("getcustomerduelist",self.duelist).then((response) => {
            self.productsCostList = response.data.cost;
            self.servicesList = response.data.servicesLists;
            self.customerlist = response.data.customerlist;
            self.filteredcustomerList = self.customerlist; 

            self.language=response.data.language;
            localStorage.setItem('lang',response.data.language);

          }).then(() => {
            self.initializeHomeContent();

            $("#customers").select2({
              width: '100%',
              placeholder: "Search Services Here...",
              "language": {
                "noResults": function () {
                  return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                }
              },
              escapeMarkup: function (markup) {
                return markup;
              }
            }).on('change', function (event) {
                self.order.cust_id= $(this).val(); 
                
            });
          }).catch((err) => {

          });;


        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      },





//----------------------------------------------------------------------------------------







    }
  }






</script>